import { renderInDocument } from '@spotahome/soyuz/client';

import LandlordLandingContainer from './main';

renderInDocument(LandlordLandingContainer);
